/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2022 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState} from 'react';
import part from '../assets/img/PartIcons/part.png';
import {ReactComponent as ArrowDown} from '../assets/img/icons/arrowDown.svg';
import {Link, useParams} from "react-router-dom";
import {useEffect} from "react";

const AccordionParts = (props) => {

    let params = useParams();
    const [open, setOpen] = useState(false);

    function clickHundler(){
        setOpen(!open);
    }

    const filterNames = ({ title }) => {
        return title.toLowerCase().indexOf(props.search.toLowerCase()) !== -1;
    };

    useEffect(() => {
        setOpen(props.isallOpen);
    }, [params, props.isallOpen]);

    return (
         <div className={`accordionParts ${open ? "opened" : ""} ${props.part.total_parts > 0 ? "" : "zero-match"} ${props.part.subcategories.filter(filterNames).length > 0 ? "" : "accordionParts--hide"}`}>
        {/*<div className={`accordionParts ${open ? "opened" : ""}`}>*/}
            <div className='accordionParts__header' onClick={clickHundler}>
                <div className='accordionParts__icon'>
                    <img src={props.part.image} alt={props.part.part_category_title} />
                </div>
                <div className='accordionParts__title'>{props.part.part_category_title}</div>
                <div className='accordionParts__num'>( {props.part.total_parts} )</div>
                <div className='accordionParts__arrow'><ArrowDown/></div>
            </div>
            {open && <div className='accordionParts__body'>
                {/*<Link to='/listing-parts' className='accordionParts__all-parts'>Show all parts in category - Air Intake System & Exhaust Parts</Link>*/}
                <div className='accordionParts__results'>
                    <div className='accordionParts__row'>
                        {props.part.subcategories.length > 0 && props.part.subcategories.map( (subcategory, index) => (
                            <div className='col-md-3 mb-4' key={index}>
                                {subcategory.parts.length > 0 && <div className='mb-2' style={{ fontSize: '16px', fontWeight: 'bold' }}>{subcategory.part_category_title}</div>}
                                <div className=''>
                                    {subcategory.parts.length > 0 && subcategory.parts.filter(filterNames).map( (part, index) => (
                                        <Link to={props.link.replace('slug', `${encodeURIComponent(part.slug)}`).replace('value', `${part.specs_slug}`)} className={`accordionParts__link ${parseInt(subcategory.parts.length) === 0 ? "accordionParts__link--empty" : ""} ${parseInt(part.count) === 0 ? "accordionParts__link--empty" : ""} `} key={index}>{part.title} {part.specs && <>({part.specs})</>}</Link>
                                    ) ) }
                                </div>
                            </div>
                        ) ) }
                    </div>
                </div>
            </div>}
        </div>
    );
};

export default AccordionParts;
